module.exports = __webpack_public_path__ + "img/s4_img@2x.ccaf32ca.png";